import { render, staticRenderFns } from "./CapCubeLayout.vue?vue&type=template&id=44a5e60c&scoped=true"
import script from "./CapCubeLayout.vue?vue&type=script&lang=js"
export * from "./CapCubeLayout.vue?vue&type=script&lang=js"
import style0 from "./CapCubeLayout.vue?vue&type=style&index=0&id=44a5e60c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_6m5rqjauvbyej62p7eiecas4wq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a5e60c",
  null
  
)

export default component.exports